export default "assets/images/logo-cafe-de-paris-white-9a614686.png";